














export default {
  name: 'BillIcon'
}
